export default "__VITE_PUBLIC_ASSET__07f04a6f__"